import type { ComponentType } from 'react'
import { AgentNodeSidebarComponent } from '../sidebar/agent-node'
import { AgentPresetConversationSidebarComponent } from '../sidebar/agent-preset-conversation'
import { AiActionSidebarComponent } from '../sidebar/ai-action'
import { AiAgentCallSidebarComponent } from '../sidebar/ai-agent-call'
import { AiAgentChatSidebarComponent } from '../sidebar/ai-agent-chat'
import { AiAgentMessageSidebarComponent } from '../sidebar/ai-agent-message'
import { AiAgentV2SidebarComponent } from '../sidebar/ai-agent-v2'
import { AiAgentWhatsappSidebarComponent } from '../sidebar/ai-agent-whatsapp'
import { AppActionSidebarComponent } from '../sidebar/app-action'
import { BranchV2SidebarComponent } from '../sidebar/branching/branch-v2'
import { BusinessHourSidebarComponent } from '../sidebar/business-hour'
import { CallForwardSidebarComponent } from '../sidebar/call-forward'
import { ConferenceBridgeSidebarComponent } from '../sidebar/conference-bridge'
import { ContactScreeningSidebarComponent } from '../sidebar/contact-screening'
import { CounterSidebarComponent } from '../sidebar/counter'
import { CreateTaskSidebarComponent } from '../sidebar/create-task'
import { CustomerFeedbackSidebarComponent } from '../sidebar/customer-feedback'
import { EndConversationSidebarComponent } from '../sidebar/end-conversation'
import { GetInputSidebarComponent } from '../sidebar/get-input'
import { HangupSidebarComponent } from '../sidebar/hangup'
import { HttpRequestSidebarComponent } from '../sidebar/http-request'
import { InitiateCallSidebarComponent } from '../sidebar/initiate-call'
import { IVRSidebarComponent } from '../sidebar/ivr-menu'
import { MultiPartyCallOutboundSidebarComponent } from '../sidebar/multi-party-call-outbound'
import { MultiPartyCallV2SidebarComponent } from '../sidebar/multi-party-call-v2'
import { OutboundScreeningSidebarComponent } from '../sidebar/outbound-screening'
import { PromptSidebarComponent } from '../sidebar/prompt'
import { QueueAndRouteSidebarComponent } from '../sidebar/queue-and-route'
import { SendChatSidebarComponent } from '../sidebar/send-chat'
import { SendMessageSidebarComponent } from '../sidebar/send-message'
import { SendWhatsappSidebarComponent } from '../sidebar/send-whatsapp'
import { StartSidebarComponent } from '../sidebar/start'
import { StreamSidebarComponent } from '../sidebar/stream'
import { UserInputSidebarComponent } from '../sidebar/user-input'
import { VoicemailSidebarComponent } from '../sidebar/voicemail'
import { FlowNodeTypes, type SidebarComponentProps } from '../types'

export const sidebarComponentMap: Record<
  FlowNodeTypes,
  // we will define the type in each sidebar component
  // biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
  ComponentType<SidebarComponentProps<any>> | undefined
> = {
  [FlowNodeTypes.start]: StartSidebarComponent,
  [FlowNodeTypes.menu]: undefined,
  [FlowNodeTypes.note]: undefined,
  [FlowNodeTypes.select_trigger]: undefined,
  // Add new sidebar components here
  [FlowNodeTypes.multi_party_call_v2]: MultiPartyCallV2SidebarComponent,
  [FlowNodeTypes.conference_bridge]: ConferenceBridgeSidebarComponent,
  [FlowNodeTypes.stream]: StreamSidebarComponent,

  [FlowNodeTypes.agent_preset_conversation]: AgentPresetConversationSidebarComponent,
  [FlowNodeTypes.ai_skills]: undefined,
  [FlowNodeTypes.end_conversation]: EndConversationSidebarComponent,
  [FlowNodeTypes.ai_agent_v2]: AiAgentV2SidebarComponent,
  [FlowNodeTypes.ai_agent_v29]: AiAgentV2SidebarComponent,
  [FlowNodeTypes.agent_node]: AgentNodeSidebarComponent,
  [FlowNodeTypes.contact_screening]: ContactScreeningSidebarComponent,
  [FlowNodeTypes.outbound_screening]: OutboundScreeningSidebarComponent,

  [FlowNodeTypes.ai_action]: AiActionSidebarComponent,

  [FlowNodeTypes.initiate_call]: InitiateCallSidebarComponent,

  [FlowNodeTypes.ai_assist]: undefined,

  [FlowNodeTypes.user_input]: UserInputSidebarComponent,

  [FlowNodeTypes.ai_agent_call]: AiAgentCallSidebarComponent,

  [FlowNodeTypes.ai_agent_message]: AiAgentMessageSidebarComponent,

  [FlowNodeTypes.ai_agent_chat]: AiAgentChatSidebarComponent,

  [FlowNodeTypes.ai_agent_whatsapp]: AiAgentWhatsappSidebarComponent,
  [FlowNodeTypes.branch_v2]: BranchV2SidebarComponent,
  [FlowNodeTypes.send_whatsapp]: SendWhatsappSidebarComponent,

  [FlowNodeTypes.send_chat]: SendChatSidebarComponent,

  [FlowNodeTypes.send_message]: SendMessageSidebarComponent,
  [FlowNodeTypes.multi_party_call_outbound]: MultiPartyCallOutboundSidebarComponent,

  [FlowNodeTypes.whatsapp_conversation]: undefined,

  [FlowNodeTypes.message_conversation]: undefined,

  [FlowNodeTypes.business_hour]: BusinessHourSidebarComponent,

  [FlowNodeTypes.app_action]: AppActionSidebarComponent,
  [FlowNodeTypes.http_request]: HttpRequestSidebarComponent,

  [FlowNodeTypes.create_task]: CreateTaskSidebarComponent,

  [FlowNodeTypes.counter]: CounterSidebarComponent,

  [FlowNodeTypes.queue_and_route]: QueueAndRouteSidebarComponent,

  [FlowNodeTypes.customer_feedback]: CustomerFeedbackSidebarComponent,

  [FlowNodeTypes.call_forward]: CallForwardSidebarComponent,

  [FlowNodeTypes.get_input]: GetInputSidebarComponent,

  [FlowNodeTypes.voicemail]: VoicemailSidebarComponent,

  [FlowNodeTypes.prompt]: PromptSidebarComponent,

  [FlowNodeTypes.ivr_menu]: IVRSidebarComponent,
  [FlowNodeTypes.hangup]: HangupSidebarComponent,
}
